const initialState = {
    target:{
        level:0,
        reg:0,
        dis:0,
        name:'Respublika'
    },
    regions:[],
    districts:[],
    map:{
        defaultZoom:6.5,
        defaultCenter:{ lat: 41.5636681, lng: 62.695678 }
    }
};

export const dateReducer = (state = initialState, {type, payload}) => {
    switch (type){
        case "SET_TARGET":
            return {...state,target: payload};
        case "SET_REGIONS":
            return {...state,regions: payload};
        case "SET_DISTRICTS":
            return {...state,districts: payload};

        default:
            return state;
    }
}

